import {Component, OnInit} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {ConsultingService, LoaderService, ReportService} from '@app/shared/services';
import {ModalDismissReasons, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {UtilsInjectable} from '@app/shared';
import {environment} from '@env/environment';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import {SelectDropDownModule} from 'ngx-select-dropdown';
import numberToWords from 'number-to-words';
import {Nl2BrPipe} from '@app/shared/pipe';

@Component({
  selector: 'app-agent-report',
  templateUrl: './agent-report.component.html',
  styleUrls: ['./agent-report.component.scss'],
  imports: [
    CommonModule, FormsModule, PageHeaderComponent, SelectDropDownModule, Nl2BrPipe, NgOptimizedImage
  ]
})
export class AgentReportComponent implements OnInit {
  user_rights: any;
  user_data: any;

  stock_data: any;
  closeResult = "";
  medicine: any;
  sale_return_quantity: any;
  sale_quantity = 0;
  fromdate = "";
  todate = "";
  start: any;
  limit: any;
  sale_list: any = [];
  customer_id = 0;
  commission = 0;
  saled: any;
  item_list: any;
  vat_list: any;
  total_vat = 0;
  total_flood = 0;
  save_rate = 0;
  gross = 0;
  price_total = 0;
  numberToWords: any;
  public institution = JSON.parse(localStorage.getItem('institution') || "{}");
  public logo_path = JSON.parse(localStorage.getItem('logo_path') || "{}");
  customer: any;
  customer_options: any;
  customer_data: any;

  constructor(private loaderService: LoaderService,
              private modalService: NgbModal,
              public consultingService: ConsultingService,
              public reportService: ReportService,
              private toastr: ToastrService,
              protected utils: UtilsInjectable,
  ) {

  }

  ngOnInit() {
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
    this.listAgent();
  }

  public getToday(): string {
    return new Date().toISOString().split('T')[0]
  }

  public listAgent() {
    const postData = {
      invoice_date_from: this.fromdate,
      invoice_date_to: this.todate,
      start: this.start,
      limit: this.limit
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.consultingService.listAgent(postData).subscribe((result: any) => {
      if (result['status'] == 'success') {
        this.stock_data = result['data'];
        this.customer = result['data'];
        this.customer_options = this.customer;
        this.setCustomer();
        this.loaderService.display(false);
      } else {

        this.loaderService.display(false);
      }
    });
  }

  getCustomerSales() {
    if (this.fromdate == "") {
      this.toastr.error("Please select from date")
    } else if (this.todate == "") {
      this.toastr.error("Please select to date")
    } else if (this.customer_id == 0) {
      this.toastr.error("Please select customer")
    } else {
      const sendJson = {
        invoice_date_from: this.fromdate,
        invoice_date_to: this.todate,
        customer_id: this.customer_id
      };
      this.loaderService.display(true)
      this.consultingService.getSales(sendJson).subscribe((result: any) => {
        this.loaderService.display(false)
        if (result.status == "success") {
          let commission = 0;
          this.sale_list = result.data;
          for (const list of this.sale_list) {

            let sum_sla_a = 0;
            let sum_sla_c = 0;
            let given_amount = 0;
            for (const data of list.SALE) {
              sum_sla_a = sum_sla_a + parseFloat(data.SLAB_A_AMOUNT)
              sum_sla_c = sum_sla_c + parseFloat(data.SLAB_C_AMOUNT)
              given_amount = given_amount + parseFloat(data.TOTAL)
            }
            list["SLAB_A_AMOUNT"] = sum_sla_a;
            list["SLAB_C_AMOUNT"] = sum_sla_c;
            list["GIVEN_AMOUNT"] = (given_amount - parseFloat(list.DISCOUNT)) + parseFloat(list.FREIGHT_CHARGE)
            list["AGENT_COMMISSION"] = given_amount - sum_sla_a;
            commission = commission + parseFloat(list.AGENT_COMMISSION)
          }
          this.commission = commission;
        } else {
          this.toastr.error("There is no sales of this customer")
          this.sale_list = [];
          this.commission = 0

        }
      });

    }
  }

  public sale_items(item: any) {
    const postData = {

      sale_id: item
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.reportService.getSale(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.saled = result['data'];
        this.item_list = result['data'].SALE;
        let i = 0;
        for (const data of this.item_list) {

          const unit = parseFloat(data.UNIT_PRICE);
          const vat = parseFloat(data.VAT);
          if (this.saled && this.saled.TIN_NUMBER == 32) {
            data["BASE_PRICE"] = ((unit / (environment.FLOOD_CESS_PERCENTAGE + 100)) * 100).toFixed(2)
          }
          if (this.saled && this.saled.TIN_NUMBER != 32) {
            data["BASE_PRICE"] = ((unit / (vat + environment.FLOOD_CESS_PERCENTAGE + 100)) * 100).toFixed(2)
          }
          this.item_list[i] = data;
          i = i + 1;
        }
        this.getVatValue();
        this.getSum();
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  getSum() {
    let total = 0;
    let save = 0;
    for (const item of this.item_list) {
      total = total + parseFloat(item.TOTAL);
      save = save + parseFloat(item.SAVE_RATE);
    }
    this.save_rate = Math.round(save);
    this.gross = total
    if (this.saled) {
      this.price_total = Math.round((this.gross - parseFloat(this.saled.DISCOUNT)) + parseFloat(this.saled.FREIGHT_CHARGE))
    } else {
      this.price_total = Math.round(this.gross)
    }
    this.numberToWords = (numberToWords.toWords(this.price_total));
  }

  public getVatValue() {
    const postData = {
      sale_id: this.saled.SALE_ID,
      state_code: this.saled.TIN_NUMBER
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.reportService.getVatValue(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.vat_list = result['data'];
        let total_vat = 0;
        let total_flood = 0;
        for (const vat of this.vat_list) {
          total_vat = total_vat + parseFloat(vat.VAT)
          total_flood = total_flood + parseFloat(vat.FLOOD_CESS)
        }
        this.total_vat = (total_vat)
        this.total_flood = (total_flood)
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  getCustomer() {
    this.customer_id = this.customer_data.CUSTOMER_ID;
  }

  public setCustomer() {
    if (this.customer_id) {
      for (let index = 0; index < this.customer.length; index++) {
        if (this.customer[index].CUSTOMER_ID == this.customer_id) {
          this.customer_data = this.customer[index];
          break;
        }
      }
    }
  }

  protected opens(content: any) {
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      windowClass: "col-md-12"
    }).result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason == ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason == ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

}
